/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcHostUsage } from './vmcHostUsage';


export interface VmcHostUsageProxyResponse { 
    'usage-date'?: string;
    usage_start_date_time?: Date;
    usage_end_date_time?: Date;
    /**
     * List of operations
     */
    max_host_usages?: Array<VmcHostUsage>;
}

